import {
  FILTER_ADDED,
  FILTER_DELETED,
  FILTERS_SET,
  SEARCH_CONTEXT_CLEARED,
  SEARCH_RESULTS_CLEARED,
  SEARCH_RESULTS_FULFILLED,
  SEARCH_RESULTS_REJECTED,
  SEARCH_RESULTS_REQUESTED,
  SEARCH_SUGGESTIONS_FULFILLED,
  SEARCH_SUGGESTIONS_REJECTED,
  SEARCH_SUGGESTIONS_REQUESTED,
  SEARCH_STORE_PAGE_NUM,
  SEARCH_STORE_CONTEXT
} from './const';

/**
 * add a search filter
 * @param {string} context - the search context
 * @param {string} k - the filter key
 * @param {string} v - the filter value
 * @returns {object} an action object
 */
export const addSearchFilter = (context, k, v) => ({
  type: FILTER_ADDED,
  context,
  filter: {
    k,
    v
  }
});

/**
 * delete a search filter
 * @param {string} context - the search context
 * @param {string} k - the filter key
 * @param {string} v - the filter value
 * @returns {object} an action object
 */
export const deleteSearchFilter = (context, k, v) => ({
  type: FILTER_DELETED,
  context,
  filter: {
    k,
    v
  }
});

/**
 * set active search filters
 * @param {string} context - the search context
 * @param {Array} filters - the array of filters
 * @returns {object} an action object
 */
export const setFilters = (context, filters) => ({
  type: FILTERS_SET,
  context,
  filters
});

/**
 * clear search state for the given context
 * @returns {object} an action object
 */
export const clearSearch = () => ({
  type: SEARCH_CONTEXT_CLEARED
});

/**
 * clear search results for the given search context
 * @returns {object} an action object
 */
export const clearSearchResults = () => ({
  type: SEARCH_RESULTS_CLEARED
});

/**
 * trigger a request to get search results
 * @param {string} context - the search context
 * @param {string} filters - the filters for search bar
 * @returns {object} an action object
 */
export const getSearchResultsRequest = (context, filters) => ({
  type: SEARCH_RESULTS_REQUESTED,
  context,
  filters
});

/**
 * handle get search results request failure
 * @param {string} context - the search context
 * @param {string} filters - the filters for search bar
 * @param {Error} error - the error object describing the failure
 * @returns {object} an action object
 */
export const getSearchResultsFailure = (context, filters, error) => ({
  type: SEARCH_RESULTS_REJECTED,
  context,
  filters,
  error
});

/**
 * handle get search suggestions request success
 * @param {string} context - the search context
 * @param {object} payload - the response payload of the successful call
 * @returns {object} an action object
 */
export const getSearchResultsSuccess = (context, payload) => ({
  type: SEARCH_RESULTS_FULFILLED,
  context,
  payload
});

/**
 * trigger a request to get search suggestions
 * @param {string} context - the search context
 * @param {string} inputValue - the value of the input for search bar
 * @returns {object} an action object
 */
export const getSearchSuggestionsRequest = (context, inputValue) => ({
  type: SEARCH_SUGGESTIONS_REQUESTED,
  context,
  inputValue
});

/**
 * handle get search suggestions request failure
 * @param {string} context - the search context
 * @param {string} inputValue - the value of the input for search bar
 * @param {Error} error - the error object describing the failure
 * @returns {object} an action object
 */
export const getSearchSuggestionsFailure = (context, inputValue, error) => ({
  type: SEARCH_SUGGESTIONS_REJECTED,
  context,
  inputValue,
  error
});

/**
 * handle get search results request success
 * @param {string} context - the search context
 * @param {object} payload - the response payload of the successful call
 * @returns {object} an action object
 */
export const getSearchSuggestionsSuccess = (context, payload) => ({
  type: SEARCH_SUGGESTIONS_FULFILLED,
  context,
  payload
});

/**
 * set active search result page number
 * @param {string} context - the search context
 * @param {object} payload - the response payload of the successful call
 * @returns {object} an action object
 */
export const storeSearchResultPageNum = (context, payload) => ({
  type: SEARCH_STORE_PAGE_NUM,
  context,
  payload
});

/**
 * set active search context
 * @param {string} context - the search context
 * @returns {object} an action object
 */
export const storeSearchContext = context => ({
  type: SEARCH_STORE_CONTEXT,
  context
});
